import { render } from "./App.vue?vue&type=template&id=31fb9db4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=31fb9db4&lang=css"

import exportComponent from "E:\\code\\软著项目\\agent\\software-agent\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__